var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCommunitiesIcon = function SvgCommunitiesIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31.07,
    height: 15.535,
    viewBox: "0 0 31.07 15.535",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_897",
    "data-name": "Group 897",
    transform: "translate(-18 -788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_896",
    "data-name": "Group 896",
    transform: "translate(18 788)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M36.825,18A2.825,2.825,0,1,1,34,20.825,2.825,2.825,0,0,1,36.825,18Z",
    transform: "translate(-11.403 -15.175)",
    fill: "#2f2f2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M11.649,20.825A2.825,2.825,0,1,1,8.825,18,2.825,2.825,0,0,1,11.649,20.825Z",
    transform: "translate(-3.175 -15.175)",
    fill: "#2f2f2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M6.237,31.531A4.924,4.924,0,0,1,7.728,28h-2.9A2.825,2.825,0,0,0,2,30.825a1.412,1.412,0,0,0,1.412,1.412H6.237Z",
    transform: "translate(-2 -18.114)",
    fill: "#2f2f2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M40.7,28h-3.12a5.276,5.276,0,0,1,1.707,3.884,3.068,3.068,0,0,1-.036.353h2.861a1.412,1.412,0,0,0,1.412-1.412A2.825,2.825,0,0,0,40.7,28Z",
    transform: "translate(-12.456 -18.114)",
    fill: "#2f2f2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M25.888,28h-12A3.883,3.883,0,0,0,10,31.884h0a1.765,1.765,0,0,0,1.765,1.765H28.007a1.765,1.765,0,0,0,1.765-1.765h0A3.883,3.883,0,0,0,25.888,28Z",
    transform: "translate(-4.351 -18.114)",
    fill: "#2f2f2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M22.237,14A4.237,4.237,0,1,1,18,18.237,4.237,4.237,0,0,1,22.237,14Z",
    transform: "translate(-6.702 -14)",
    fill: "#2f2f2f",
    fillRule: "evenodd"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCommunitiesIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/communities-icon.b231be7b.svg";
export { ForwardRef as ReactComponent };